<template>
    <button
        :aria-expanded="companyNavigationStore.showSideNav"
        aria-label="Main menu"
        class="ml-4 size-8 cursor-pointer legacy-md:hidden"
        type="button"
    >
        <img
            alt=""
            src="@/assets/svg/unified-menu.svg"
        />
    </button>
</template>

<script setup lang="ts">
import { useCompanyNavigationStore } from '@/stores/company/company-navigation.store';

const companyNavigationStore = useCompanyNavigationStore();
</script>
